!customElements.get("op-lens-slider") && customElements.define("op-lens-slider", class extends HTMLElement {
    connectedCallback() {
        this.config = JSON.parse(this.querySelector("[data-swiper-cfg]")?.textContent || '{}');
        this.colors = this.dataset.colors || '';

        this.swiperElement = this.querySelector(`.swiper`);
    
        if (this.config?.pagination?.renderBullet === 'renderSlideBullet') {
            if (this.colors && this.colors.trim() !== '') {
                const bulletColors = this.colors.split(',').map(label => label.trim());
    
                this.config.pagination.renderBullet = function (index, className) {
                    return `<span class="${className}" role="tab" style="background-color:${bulletColors[index]};"></span>`;
                };
            } else {
                delete this.config.pagination.renderBullet;
            }
        }
    
        // Salviamo il riferimento al contenitore dei bullet
        this.paginationContainer = this.swiperElement?.querySelector('.swiper-pagination');

        this.swiper = window.Swiper ? new window.Swiper(this.swiperElement, this.config) : null;

        this.swiper?.on('slideChange', this.onSlideChange.bind(this));
    }

    disconnectedCallback () {
        this.swiper?.destroy();
    }

    onSlideChange () {
        const activeBullet = this.swiperElement?.querySelector('.swiper-pagination-bullet-active');
            
        if (activeBullet && this.paginationContainer) {
            const containerRect = this.paginationContainer.getBoundingClientRect();
            const bulletRect = activeBullet.getBoundingClientRect();
            // Calcoliamo l’offset in modo da centrare il bullet attivo
            const offset = bulletRect.left - containerRect.left - (containerRect.width / 2) + (bulletRect.width / 2);

            this.paginationContainer.scrollBy({
                left: offset,
                behavior: 'smooth'
            });
        }
    }
});